/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PngInputs */

const en_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const es_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const fr_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const de_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const ja_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const zh_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const ar_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const id_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const it_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const ru_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const pt_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const ko_val_png = /** @type {(inputs: Val_PngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

/**
* | output |
* | --- |
* | "PNG" |
*
* @param {Val_PngInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_png = /** @type {((inputs?: Val_PngInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PngInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_png(inputs)
	if (locale === "es") return es_val_png(inputs)
	if (locale === "fr") return fr_val_png(inputs)
	if (locale === "de") return de_val_png(inputs)
	if (locale === "ja") return ja_val_png(inputs)
	if (locale === "zh") return zh_val_png(inputs)
	if (locale === "ar") return ar_val_png(inputs)
	if (locale === "id") return id_val_png(inputs)
	if (locale === "it") return it_val_png(inputs)
	if (locale === "ru") return ru_val_png(inputs)
	if (locale === "pt") return pt_val_png(inputs)
	return ko_val_png(inputs)
});